import { useEffect } from 'react';

const SOFT_ERROR = '#FFB1AE';
const STRONG_ERROR = '#CE302A';

const patchStyleTag = (el) => {
  if (!el || el.nodeName !== 'STYLE') return;
  const text = el.textContent;
  if (text && text.includes(SOFT_ERROR)) {
    el.textContent = text.split(SOFT_ERROR).join(STRONG_ERROR);
  }
};

const patchAllStyles = () => {
  document.querySelectorAll('style').forEach(patchStyleTag);
};

const UiKitErrorColorFix = () => {
  useEffect(() => {
    patchAllStyles();

    const observer = new MutationObserver((mutations) => {
      for (const mutation of mutations) {
        mutation.addedNodes.forEach(patchStyleTag);
        if (mutation.target?.nodeName === 'STYLE') {
          patchStyleTag(mutation.target);
        }
      }
    });

    observer.observe(document.head, {
      childList: true,
      subtree: true,
      characterData: true,
    });

    return () => observer.disconnect();
  }, []);

  return null;
};

export default UiKitErrorColorFix;
